import { render, staticRenderFns } from "./AdminAccountCopyDialog.vue?vue&type=template&id=604e960d&"
import script from "./AdminAccountCopyDialog.vue?vue&type=script&lang=js&"
export * from "./AdminAccountCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports